<span class="mat-body-2">
  {{ getErrorLangKey(pbbFormControl.errors) | translate }}
</span>
